/*
 * @LastEditors: boqodo
 * @Author: boqodo
 * @Date: 2025-03-17 23:04:45
 * @LastEditTime: 2025-04-13 18:12:15
 * @Description: filecontent
 * @FilePath: /h5-astx-app/src/components/TabBar.js
 */

import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const TabBar = () => {
  const location = useLocation();
  const path = location.pathname;

  // 判断当前路径是否激活
  const isActive = (route) => {
    if (route === '/' && path === '/') return true;
    if (route !== '/' && path.startsWith(route)) return true;
    return false;
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 h-[63px] bg-white/90 backdrop-blur-md border-t border-[#e0e0e0] flex justify-around items-center">
      <Link to="/" className={`flex flex-col items-center text-xs ${isActive('/') ? 'text-blue-500' : 'text-gray-500'}`}>
        <i className="fa-solid fa-house text-[22px] mb-1"></i>
        <span>首页</span>
      </Link>
      {/* 功能暂时隐藏 */}
      {/* <Link to="/books" className={`flex flex-col items-center text-xs ${isActive('/books') ? 'text-blue-500' : 'text-gray-500'}`}>
        <i className="fa-solid fa-book text-[22px] mb-1"></i>
        <span>课本</span>
      </Link>
      <Link to="/progress" className={`flex flex-col items-center text-xs ${isActive('/progress') ? 'text-blue-500' : 'text-gray-500'}`}>
        <i className="fa-solid fa-chart-simple text-[22px] mb-1"></i>
        <span>进度</span>
      </Link>  */}
      <Link to="/settings" className={`flex flex-col items-center text-xs ${isActive('/settings') ? 'text-blue-500' : 'text-gray-500'}`}>
        <i className="fa-solid fa-gear text-[22px] mb-1"></i>
        <span>设置</span>
      </Link>
    </div>
  );
};

export default TabBar;